import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { TenantProvider } from "@/context/TenantContext";
import { DashboardShell } from "@/components/DashboardShell";
import {
  LayoutDashboard, CalendarDays, Users, Wallet, Settings, Plug,
} from "lucide-react";
import StaffHomePage from "./staff/StaffHomePage";
import AgendaPage from "./staff/AgendaPage";
import ClientsPage from "./staff/ClientsPage";
import FidelityGiftPage from "./staff/FidelityGiftPage";
import StaffSettingsPage from "./staff/StaffSettingsPage";
import IntegrationsPage from "./staff/IntegrationsPage";

function StaffDashboardInner() {
  const { slug } = useParams();
  const NAV = [
    { to: `/${slug}/staff`, label: "Dashboard", icon: LayoutDashboard, testId: "home", end: true },
    { to: `/${slug}/staff/agenda`, label: "Agenda", icon: CalendarDays, testId: "agenda" },
    { to: `/${slug}/staff/clienti`, label: "Clienti", icon: Users, testId: "clienti" },
    { to: `/${slug}/staff/fidelity`, label: "Fidelity & gift", icon: Wallet, testId: "fidelity" },
    { to: `/${slug}/staff/integrazioni`, label: "Integrazioni", icon: Plug, testId: "integrations" },
    { to: `/${slug}/staff/impostazioni`, label: "Impostazioni", icon: Settings, testId: "settings" },
  ];
  return (
    <DashboardShell nav={NAV} testId="staff-dashboard">
      <Routes>
        <Route index element={<StaffHomePage />} />
        <Route path="agenda" element={<AgendaPage />} />
        <Route path="clienti" element={<ClientsPage />} />
        <Route path="fidelity" element={<FidelityGiftPage />} />
        <Route path="integrazioni" element={<IntegrationsPage />} />
        <Route path="impostazioni" element={<StaffSettingsPage />} />
        <Route path="*" element={<Navigate to={`/${slug}/staff`} replace />} />
      </Routes>
    </DashboardShell>
  );
}

export default function StaffDashboard() {
  return (
    <TenantProvider>
      <StaffDashboardInner />
    </TenantProvider>
  );
}
